import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Toolbar } from '@mui/material'
import TopBar from './TopBar'
import Sidebar from './Sidebar'
import { usePortalStore } from '../stores/portalStore'

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { config } = usePortalStore()

  const handleToggle = () => setMobileOpen(!mobileOpen)
  const handleClose = () => setMobileOpen(false)

  const glassmorphism = (config?.glassmorphism ?? false) && config?.backgroundMode === 'image'
  const backgroundMode = config?.backgroundMode || 'solid'
  const contentBg = config?.contentBackgroundColor || '#f8fafc'
  const images = config?.backgroundImages || []

  const showImageBg = backgroundMode === 'image' && glassmorphism
  // Inside portal: always use the first image (static, no carousel)
  const portalBgImage = showImageBg && images.length > 0 ? images[0] : undefined

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        minHeight: '100vh',
        bgcolor: portalBgImage ? 'transparent' : contentBg,
      }}
    >
      {/* Static background image inside portal (only when image + glassmorphism) */}
      {portalBgImage && (
        <Box
          component="img"
          src={portalBgImage}
          alt=""
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        />
      )}

      <TopBar onMenuToggle={handleToggle} />
      <Sidebar mobileOpen={mobileOpen} onClose={handleClose} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - 260px)` },
          minHeight: '100vh',
          bgcolor: 'transparent',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  )
}
